const ExtendedProperties = ({ config, isEmptyMileageBid, renderExtendedField, showAllInEmptyMileageBid }) => {
    if (!config || Object.keys(config).length === 0) {
        return null;
    }
    const properties = Object.values(config).filter(
        (property) => !isEmptyMileageBid || showAllInEmptyMileageBid || property.showInEmptyMileageBids,
    );
    if (!properties.length) {
        return null;
    }
    return properties.map(renderExtendedField);
};

export default ExtendedProperties;
